import React from 'react';
import { usePageControl } from './context/PageControlContext';

import Home from './pages/Home';
import Module1 from './pages/offline/Module1';
import Module2 from './pages/offline/Module2';
import Module3 from './pages/offline/Module3';
import Module4 from './pages/offline/Module4';
import Module5_1 from './pages/offline/Module5_1';
import Module5 from './pages/offline/Module5';
import Module6 from './pages/offline/Module6';
import Module7 from './pages/offline/Module7';
import Module8 from './pages/offline/Module8';
import Module9 from './pages/offline/Module9';
import Module10 from './pages/offline/Module10';
import Module11 from './pages/offline/Module11';
import Module12 from './pages/offline/Module12';
import Module13 from './pages/offline/Module13';
import Module14 from './pages/offline/Module14';
import Module15 from './pages/offline/Module15';
import Module16 from './pages/offline/Module16';
import Module17 from './pages/offline/Module17';
import Module18 from './pages/offline/Module18';
import Module19 from './pages/offline/Module19';
import Module20 from './pages/offline/Module20';
import Module21 from './pages/offline/Module21';
import AppAdmin from './pages/AppAdmin';
import VideoDownload from './pages/VideoDownload';

// Defines which component belongs to each 'page'
// See also pageConfig.js
const pages = {
  'home': Home,
  'module-1': Module1,
  'module-2': Module2,
  'module-3': Module3,
  'module-4': Module4,
  'module-5_1': Module5_1,
  'module-5': Module5,
  'module-6': Module6,
  'module-7': Module7,
  'module-8': Module8,
  'module-9': Module9,
  'module-10': Module10,
  'module-11': Module11,
  'module-12': Module12,
  'module-13': Module13,
  'module-14': Module14,
  'module-15': Module15,
  'module-16': Module16,
  'module-17': Module17,
  'module-18': Module18,
  'module-19': Module19,
  'module-20': Module20,
  'module-21': Module21,
  'app-admin': AppAdmin,
  'video-download': VideoDownload,
};


function AppFlow() {

  const { currentPage } = usePageControl();

  const PageComponent = pages[currentPage] || Home;

  return <PageComponent />;

}

export default AppFlow;